export type SupportedLocale = "pt" | "en" | "es";

function canUseLocalStorage(): boolean {
  return (
    typeof localStorage !== "undefined" &&
    localStorage !== null &&
    typeof localStorage.getItem === "function"
  );
}

export function getPathLocale(
  pathname = typeof window !== "undefined" ? window.location.pathname : "",
): SupportedLocale | null {
  if (pathname === "/pt" || pathname.startsWith("/pt/")) return "pt";
  if (pathname === "/es" || pathname.startsWith("/es/")) return "es";
  return null;
}

export function getDeviceLocale(): SupportedLocale {
  // Localized editorial URLs are authoritative. This keeps /pt/ and /es/
  // content stable even when a browser locale was selected previously.
  const pathLocale = getPathLocale();
  if (pathLocale) return pathLocale;

  const stored = canUseLocalStorage()
    ? localStorage.getItem("stalkie_web_locale")
    : null;
  if (stored === "pt" || stored === "en" || stored === "es") return stored;

  const language =
    typeof navigator !== "undefined"
      ? (navigator.language?.toLowerCase() ?? "en")
      : "en";
  if (language.startsWith("pt")) return "pt";
  if (language.startsWith("es")) return "es";
  return "en";
}

// The first render must be identical on the server and in the browser. The
// browser preference is applied by the app after hydration instead of during
// module evaluation, which would make SSR output differ from the client.
export function getInitialLocale(): SupportedLocale {
  return getPathLocale() ?? "en";
}

let activeLocale: SupportedLocale = getInitialLocale();

export function getActiveLocale(): SupportedLocale {
  return activeLocale;
}

export function setActiveLocale(locale: SupportedLocale): void {
  activeLocale = locale;
  if (canUseLocalStorage()) {
    localStorage.setItem("stalkie_web_locale", locale);
  }
}
